import "./householdInfo.scss"
import { useEffect, useState } from "react"
import TextInput from "../../../Components/Input/TextInput"
import ProgressBar from "../../../Components/ProgressBar/ProgressBar"
import NumberPickerInput from "../../../Components/Input/NumberPickerInput"
import TextareaInput from "../../../Components/Input/TextareaInput"
import { useNavigate } from "react-router-dom"
import PetInfo from "./PetInfo"
import axios from "axios"
import config from "../../../config/config"
import Cookies from "universal-cookie"
import { usePremiumFlow } from "Context/flowPremiumContext/FlowPremiumContext"
function HouseholdInfo() {
  const premiumFlow = usePremiumFlow()
  const [petList, setPetList] = useState([])
  const navigate = useNavigate()
  const [hasPets, setHasPets] = useState(null)
  const [isSmoker, setIsSmoker] = useState(false)
  const [needAccessibleHome, setNeedAccessibleHome] = useState(false)
  const [tenantCount, setTenantCount] = useState(0)
  const [minorCount, setMinorCount] = useState(0)
  const [parkingCount, setParkingCount] = useState(0)
  const [rentDuration, setRentDuration] = useState(0)
  const [monthlyIncome, setMonthlyIncome] = useState(0)
  const [description, setDescription] = useState("")
  const [isUpdating, setIsUpdating] = useState(false)

  const cookies = new Cookies()
  const currApplicantId = localStorage.getItem("currentApplicantId")

  const [minorErr, setMinorErr] = useState(false)
  const [minorErrMsg, setMinorErrMsg] = useState("")
  const MINOR_EXCEEDS_TENANT = new Error(
    "Minor count exceeds tenant count"
  )

  const [rentingDurationErr, setRentingDurationErr] = useState({hasError: false, msg: ""})

  const trackStateFromDb = (data) => {
    setHasPets(data.has_pets)
    setPetList(data.pets)
    setIsSmoker(data.smoke)
    setNeedAccessibleHome(data.accessible)
    setTenantCount(data.tenant_count)
    setMinorCount(data.minor_count)
    setParkingCount(data.parking_count)
    setRentDuration(data.renting_duration)
    setMonthlyIncome(data.monthly_income)
    setDescription(data.description)
  }

  const validateMinors = () => {
    if (minorCount > tenantCount) {
      setMinorErr(true)
      throw MINOR_EXCEEDS_TENANT
    }
    setMinorErr(false)
  }

  const handleSubmit = () => {
    try {
      validateMinors()
    } catch (e) {
      setMinorErrMsg(e.message)
      setMinorErr(true)
    }
    handleNextButton()
  }

  useEffect(() => {
    // Check for existing application data
    if (currApplicantId !== undefined)
      axios
        .get(`${config.BASE_URL}api/household/${currApplicantId}`, {
          headers: {
            Authorization: "Bearer " + cookies.get("auth_token"),
          },
        })
        .then((res) => {
          if (res.data !== "") {
            setIsUpdating(true)
            trackStateFromDb(res.data.household)
          }
        })
        .catch((err) => {
          console.log("Error: ", err)
        })
  }, [])

  const handleNextButton = () => {
    if (rentingDurationErr.hasError) {
      return
    }
    // Change endpoint if updating
    const urlString = isUpdating
      ? `${config.BASE_URL}api/household/${currApplicantId}`
      : `${config.BASE_URL}api/household`

    axios
      .post(
        urlString,
        {
          tenant_count: tenantCount,
          minor_count: minorCount,
          monthly_income: monthlyIncome,
          renting_duration: rentDuration,
          parking_count: parkingCount,
          // The issue from the backend is here.
          smoke: isSmoker,
          accessible: needAccessibleHome,
          has_pets: hasPets,
          pets: hasPets
            ? petList.map(({ type, size }) => ({
                type,
                size,
              }))
            : [],
          description,
          application_id: localStorage.getItem(
            "currentApplicationId"
          ),
        },
        {
          headers: {
            Authorization: "Bearer " + cookies.get("auth_token"),
          },
        }
      )
      .then((res) => {
        const data = res.data
        if (!data.has_errors) {
          // skip guarantor + premium for now @todo
          //   navigate("/tenant/guarantor")
          if (
            premiumFlow.hasData &&
            premiumFlow.premiumFeatures.length
          ) {
            navigate("/tenant/premium/paid")
          } else {
            navigate("/tenant/application-preview")
          }
        }
      })
      .catch((e) => {
        // TODO: ERROR HANDLING
        console.error(e)
      })
  }
  const addPet = () => {
    setPetList((prevPetList) => {
      return [
        ...prevPetList,
        {
          // due to being able to remove pets its not safe to use the length of the array as it can lead to duplicated ids
          id: Math.random().toString(36),
          type: null,
          size: null,
        },
      ]
    })
  }

  const removePet = (petId) => {
    // This is being passed an id, not an item
    const newPetList = petList.filter(
      (listItem) => listItem.id !== petId
    )
    setPetList(newPetList)
  }
  const updatePet = (pet) => {
    setPetList(
      petList.map((item) => {
        return item.id === pet.id ? pet : item
      })
    )
  }
  return (
    <section className="HouseholdInfo">
      <div className="container">
        <button
          className="btn btn--back"
          onClick={() => {
            navigate(-1)
          }}
        >
          back
        </button>
        <ProgressBar type="tenant" step="5" />

        <h1>household & personal info</h1>

        <div className="row">
          <div className="col-xl-4 col-md-6">
            <NumberPickerInput
              min={0}
              max={100}
              label="how many people are you renting with?"
              name="tenant_count"
              value={tenantCount}
              onChange={setTenantCount}
              hasError={tenantCount > 100}
            />
          </div>
          <div className="col-xl-4 col-md-6">
            <NumberPickerInput
              min={0}
              label="how many of those are children/minors?"
              name="minor_count"
              value={minorCount}
              onChange={setMinorCount}
              hasError={minorCount > tenantCount}
            />
            {minorErr ? (
              <p className="text-danger">{minorErrMsg}</p>
            ) : null}
          </div>
          <div className="col-xl-4 col-md-6">
            <NumberPickerInput
              min={0}
              label="how many parking spots do you require?"
              name="parking_count"
              value={parkingCount}
              onChange={setParkingCount}
              hasError={parkingCount > 100}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xl-4 col-md-6">
            <TextInput
              type="number"
              label="how many months do you want to rent for ?"
              name="rent_duration"
              value={rentDuration}
              hasError={rentingDurationErr.hasError}
              onBlur={(e) => {
                if (e.target.value.match(/\d/)) {
                  if (e.target.value === "0") {
                    setRentingDurationErr({hasError: true, msg: "please enter valid a number"})
                    setRentDuration("")
                  } else {
                    setRentDuration(e.target.value)
                    setRentingDurationErr({hasError: false, msg: ""})
                  }
                } else {
                  setRentingDurationErr({hasError: true, msg: "please enter valid a number"})
                  setRentDuration("")
                }
              }}
              onChange={(e) => {
                if (e.target.value >= 0)
                  setRentDuration(e.target.value)
              }}
            />
            {rentingDurationErr.hasError && (
              <p className="text-danger">{rentingDurationErr.msg}</p>
            )}
          </div>
          <div className="col-xl-4 col-md-6">
            <TextInput
              type="number"
              label="what is the total household monthly income (everyone living in the home)?"
              name="monthly_income"
              value={monthlyIncome}
              onChange={(e) => {
                if (e.target.value >= 0)
                  setMonthlyIncome(e.target.value)
              }}
              hasError={monthlyIncome > 1000000}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xl-4 col-md-6">
            <div className="form-group">
              <label>
                do you or any member of your household smoke?
              </label>
              <div className="form-choose-group">
                <button
                  id="smoker"
                  className={
                    isSmoker === true
                      ? "choose-input-group label active"
                      : "choose-input-group label"
                  }
                  onClick={() => {
                    setIsSmoker(true)
                  }}
                >
                  yes
                </button>
                <button
                  id="nonSmoker"
                  className={
                    isSmoker === false
                      ? "choose-input-group label active"
                      : "choose-input-group label"
                  }
                  onClick={() => {
                    setIsSmoker(false)
                  }}
                >
                  no
                </button>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-6">
            <div className="form-group">
              <label>do you require an accessible home?</label>
              <div className="form-choose-group">
                <button
                  className={
                    needAccessibleHome === true
                      ? "choose-input-group label active"
                      : "choose-input-group label"
                  }
                  onClick={() => {
                    setNeedAccessibleHome(true)
                  }}
                >
                  yes
                </button>
                <button
                  className={
                    needAccessibleHome === false
                      ? "choose-input-group label active"
                      : "choose-input-group label"
                  }
                  onClick={() => {
                    setNeedAccessibleHome(false)
                  }}
                >
                  no
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-4 col-md-6">
            <div className="form-group">
              <label>
                do you have any pets as part of your household?
              </label>
              <div className="form-choose-group">
                <button
                  className={
                    hasPets === true
                      ? "choose-input-group label active"
                      : "choose-input-group label"
                  }
                  onClick={() => {
                    setHasPets(true)
                  }}
                >
                  yes
                </button>
                <button
                  className={
                    hasPets === false
                      ? "choose-input-group label active"
                      : "choose-input-group label"
                  }
                  onClick={() => {
                    setHasPets(false)
                  }}
                >
                  no
                </button>
              </div>
            </div>
          </div>
        </div>

        {hasPets &&
          petList.map((petInfo) => (
            <PetInfo
              key={petInfo.id}
              onChange={updatePet}
              removePet={() => {
                removePet(petInfo.id)
              }}
              {...petInfo}
            />
          ))}
        {hasPets && (
          <button
            className="btn btn--secondary-alt btn--small mb-4"
            onClick={() => {
              addPet()
            }}
          >
            add a pet
          </button>
        )}
        <TextareaInput
          label="this is the space to tell the landlord a little bit about your household"
          name="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          hasError={description.length > 1000}
        />

        <div className="btn-group">
          <button className="btn btn--primary" onClick={handleSubmit}>
            next
          </button>
        </div>
      </div>
    </section>
  )
}

export default HouseholdInfo
